import planMaterialStockChange from './planMaterialStockChange'

/**
 * @typedef {object} StockChange
 * @property {string} MaterialID - ID of the material being deducted/restored
 * @property {number} delta - Negative deducts, positive restores
 */

/**
 * Pre-flight check: welke van deze voorraadmutaties zouden de voorraad onder 0
 * brengen? Puur, op een meegegeven materialenlijst — bedoeld om de gebruiker te
 * laten bevestigen VOORDAT er iets wordt weggeschreven.
 *
 * De echte, gezaghebbende controle gebeurt daarna alsnog in
 * `runMaterialStockChange`, dat het materiaal vers ophaalt.
 *
 * @param {Array<{ID: string, Title?: string, Kind?: string, QuantityInStock?: number}>} materials
 * @param {Array<StockChange>} changes
 * @returns {Array<{MaterialID: string, Title: string, Required: number, Available: number, Resulting: number}>}
 */
const collectNegativeStockWarnings = (materials, changes) => {
    const byID = new Map((materials || []).map((m) => [m.ID, m]))

    return (changes || [])
        .map(({ MaterialID, delta }) =>
            planMaterialStockChange(byID.get(MaterialID) || null, delta, { allowNegative: true }).goesNegative
        )
        .filter(Boolean)
}

export default collectNegativeStockWarnings
